import styled from 'styled-components';

import { Skeleton } from 'ui/skeleton';
import { colors, spacing } from 'ui/theme';

const SettingSkeleton = styled(Skeleton)`
  height: ${spacing.x6};
  margin-bottom: ${spacing.double};
  background-color: ${colors.grey5};
`;

export const SubscriptionSettingsListSkeleton = () => (
  <>
    <SettingSkeleton />
    <SettingSkeleton />
    <SettingSkeleton />
  </>
);
